module.exports = __webpack_public_path__ + "img/cover-promotion-bg-mobile.fd24d941.jpg";